module.exports = __webpack_public_path__ + "img/icon-brave.7e045734.svg";